const sendList = {
    path: 'sendList',
    component: resolve => require(['@/pages/admin/message/sendList/index.vue'], resolve)
}

export default sendList